export default __webpack_public_path__ + "static/media/9homies-logo-white.50b5c049.svg";